export const CLOSED_ACCORDION_LIST_TITLE = 'When you’re logged in you can:';
export const OPENED_ACCORDION_LIST_TITLE = 'Have you tried logging in?';
export const OPENREACH_APPT_LINK_LABEL = 'Prepare for your engineer visit';
export const NON_FTTP_OPENREACH_APPT_LINK_URL =
  'https://business.bt.com/help/article/broadband-and-internet/getting-started/how-is-bt-business-broadband-installed/';
export const FTTP_OPENREACH_APPT_LINK_URL =
  'https://business.bt.com/help/article/broadband-and-internet/fibre-to-the-premises-fttp/fibre-premises-installed/';
export const NON_FTTP_OPENREACH_APPT_LINK_ANALYTICS =
  'openreach engineer appointment:watch our video on non fttp broadband installation';
export const FTTP_OPENREACH_APPT_LINK_ANALYTICS =
  'openreach engineer appointment:watch our video on fttp broadband installation';
export const FTTP_PRODUCT_CATEGORY = 'FTTP';

export const CVE_APP_PHONE_TITLE =
  'Once your broadband service is ready, you can activate your Cloud Voice Express service in the app. You can also find out how to set up your new phones.';
export const CVE_APP_TITLE =
  'Once your broadband service is ready, you can activate your Cloud Voice Express service in the app:';
export const LIVE_CHAT_TITLE = 'Having trouble activating your service? Send us a message on:';

export const CISCO_DESK_PHONE_SETUP_URL = 'https://www.bt.com/business/cloudvoiceexpressdeskphone';
export const YEALINK_CORDLESS_PHONE_SETUP_URL = 'https://www.bt.com/business/cloudvoiceexpresscordless';
export const ATA_PHONE_ADAPTOR_SETUP_URL = 'https://www.bt.com/business/cloudvoiceexpressphoneadaptor';
export const CVE_SETUP_URL = 'https://www.bt.com/business/getstartedcloudvoiceexpress';
export const ATA_PHONE_ADAPTOR_TITLE = 'ATA 191/192 analogue phone adaptor';
export const CISCO_DESK_PHONE_TITLE = 'Cisco 6861 desk phone';
export const YEALINK_CORDLESS_PHONE_TITLE = 'Yealink W73P/W73H cordless phone';
export const CVE_TITLE = 'Cloud Voice Express app';
export const CVE_HEADING = 'Once your broadband service is ready';
export const CVE_SUBTITLE = 'You can activate Cloud Voice Express using the:';
export const CVE_EQUIPMENT_HEADING = "Then, you can set up any equipment you've ordered:";
